import { useSelector } from 'react-redux';

import { selectProductColorVariations } from '@selectors/products';
import { selectShopEventProducts } from '@selectors/shopEvent';

import { PRODUCT_TYPE } from '@common/constants/products';

export const useProductColorVariationsData = ({ type, ids }) => {
  const defaultProductColorVariations = useSelector(
    selectProductColorVariations(ids),
  );
  const shopEventProductColorVariations = useSelector(
    selectShopEventProducts(ids),
  );

  switch (type) {
    case PRODUCT_TYPE.SHOP_EVENT:
      return shopEventProductColorVariations;

    case PRODUCT_TYPE.DEFAULT:
    default:
      return defaultProductColorVariations;
  }
};
